
import React, { useEffect, useState, useRef } from "react"
import { Picker, Button, Space, Input, Image } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
import styles from "./uploadToOss.module.scss";
import { BASE_URL } from '../../config/config';
import OSS from "ali-oss";
import ImagePicker from '../image-picker/index';
import { ApiCore } from '../../api';
import { classPrefix } from "@hm/hm-design-mobile/es/components/tabs/tabs";

const api = new ApiCore();

const uploadToOss = 'upload_to_oss_component'; // 区分来源

const UploadToOss = (props: any) => {

    //图片
    const [photos, setPhotos] = useState<any>([]);
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    // 业务名称
    const [businessName, setBusinessName] = useState<any>('');
    // 图片名称
    const [imgName, setImgName] = useState<any>('');
    // 图片名称前缀
    const [imgNamePrefix, setImgNamePrefix] = useState<any>('');
    // 图片名称后缀
    const [imgNameSuffix, setImgNameSuffix] = useState<any>('');

    const mPhotoRef = useRef();

    useEffect(() => {
        document.title = '图片上传';
        getOssData();
    }, [])

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            }
        })
    };

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
     const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })

        return newJson
    }

    //当图片选择改变时
    const onPhotoChange = (files: any) => {
        setPhotos(files)
    }

    // 实时上传方法
    const onUpload = (item: any): Promise<object | undefined> => {
        let client = new OSS({ ...filterPathPre(ossData, 'image') });
        return new Promise((resolve, reject) => {
            if (!businessName) {
                Toast.info('请输入业务名称', 0.7)
                return reject('未输入业务名称');
            }
            // if (!imgName) {
            //     Toast.info('请输入图片名字', 0.7)
            //     return reject('未输入图片名称');
            // }
            const file = item.file;
            let _businessName = businessName // 业务名称
            let _imgName =  imgName; // 图片名称
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                const fileName = file.name.slice(0, file.name.lastIndexOf('.'));
                _imgName = imgNamePrefix + (imgName || fileName) + imgNameSuffix;
                const path = `${ossData.pathPre}${uploadToOss}/${_businessName}/${_imgName}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    resolve({ url: url });
                })
            }
        });
    };

    return (
        <div className={styles.upload_to_oss}>
                <Input
                    className={styles.busines_name}
                    placeholder='请输入业务或模块名称，请用英文描述(必须)'
                    value={businessName}
                    onChange={val => {
                        setBusinessName(val)
                    }}
                />
                <Input
                    className={styles.img_name}
                    placeholder='请输入图片名称前缀(可选)'
                    value={imgNamePrefix}
                    onChange={val => {
                        setImgNamePrefix(val)
                    }}
                />
                <Input
                    className={styles.img_name}
                    placeholder='请输入图片名称，默认上传图片名称，请用英文描述(可选)'
                    value={imgName}
                    onChange={val => {
                        setImgName(val)
                    }}
                />
                <Input
                    className={styles.img_name}
                    placeholder='请输入图片名称后缀(可选)'
                    value={imgNameSuffix}
                    onChange={val => {
                        setImgNameSuffix(val)
                    }}
                />
                <div className={styles.upload_url_preview}>
                    <div>
                        预计生成图片的地址：
                    </div>
                    <div>
                        {`${BASE_URL ? BASE_URL.split('/server')[0] : ''}/(${ossData.pathPre})${uploadToOss}/${businessName ? businessName : '业务或模块名称'}/${imgNamePrefix}${imgName ? imgName : '图片名称'}/(.png、.jpg、.svg...)`}
                    </div>
                </div>
                <div className={styles.upload_area}>
                    <ImagePicker
                        ref={mPhotoRef}
                        filesList={photos}
                        onChange={onPhotoChange}
                        multiple={false}
                        accept="image/*|video/*"
                        max={100}
                        mode="cover"
                        onUpload={onUpload}
                        width="22%"
                        onFail={() => { Toast.fail('上传失败！', 1) }}
                        config={['defaultDashed']}
                        disabled={false}
                    />
                </div>
                <div className={styles.content}>
                    {
                        photos && photos.map((val: any, index: number) => (
                            <div className={styles.url_link} key={index} contentEditable="true">
                                {(val.url && (val.url.indexOf('http') == 0)) ? val.url : null}
                            </div>
                        ))
                    }
                </div>
        </div>
    )
}

export default UploadToOss;